import { render } from "./AreaInformation.vue?vue&type=template&id=00fb8ef2&ts=true"
import script from "./AreaInformation.vue?vue&type=script&lang=ts"
export * from "./AreaInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__